import { render, staticRenderFns } from "./RegionCourtForm.vue?vue&type=template&id=50bcc31f"
import script from "./RegionCourtForm.vue?vue&type=script&lang=js"
export * from "./RegionCourtForm.vue?vue&type=script&lang=js"
import style0 from "./RegionCourtForm.vue?vue&type=style&index=0&id=50bcc31f&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports